import MainContent from "../components/MainContent"




const Home = () => {



  return <MainContent></MainContent>
}

export default Home
